import { useMemo } from 'react'
import type { PerilFragment } from '@/services/graphql/generated'
import { useFormatComparisonValue } from '@/utils/useFormatComparisonValue'
import {
  type ComparisonTableBody,
  type ComparisonTableHead,
  type ComparisonTableProps,
} from 'ui/src/components/ComparisonTable/ComparisonTable.types'
import { DesktopComparisonTable } from 'ui/src/components/ComparisonTable/DesktopComparisonTable'
import type { VariantPerils } from '../PerilsTable'
import { tableWrapper } from './PerilsTableDesktop.css'

type Props = {
  allPerils: Array<PerilFragment>
  variantsPerils: Array<VariantPerils>
  heading?: string
}

export function PerilsTableDesktop({ allPerils, variantsPerils, heading }: Props) {
  const formatValue = useFormatComparisonValue()

  const table = useMemo<ComparisonTableProps>(() => {
    const head: ComparisonTableHead = [
      heading ?? '',
      ...variantsPerils.map((variant) => {
        const headerValue = variant.displayNameSubtype
        return headerValue
      }),
    ]

    const body: ComparisonTableBody = allPerils.map((peril) => [
      { title: peril.title, description: peril.description, perilsColor: peril.colorCode },
      ...variantsPerils.map((variant) => formatValue(variantHasPeril(variant.perils, peril.title))),
    ])

    return { head, body }
  }, [variantsPerils, allPerils, heading, formatValue])

  return (
    <div className={tableWrapper}>
      <DesktopComparisonTable {...table} />
    </div>
  )
}

const variantHasPeril = (perils: Array<PerilFragment>, perilTitle: string) =>
  perils.some((peril) => peril.title === perilTitle)
